/* eslint react/no-did-mount-set-state: 0 */
/* eslint react/prop-types: 0 */
/* eslint consistent-return: 0 */
import React from 'react';
import { connect } from 'react-redux';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './ModalYaTomoTurno.css';
import redirectTo from '../../../utils/redirectTo';

class ModalYaTomoTurno extends React.Component {
  componentDidMount() {
    // $('#ModalYaTomoTurno').modal({ backdrop: 'static', keyboard: false });
    // $('.close').hide();
  }
  showDateModal = date => {
    const days = [
      'Lunes',
      'Martes',
      'Miércoles',
      'Jueves',
      'Viernes',
      'Sábado',
      'Domingo',
    ];
    const months = [
      'Enero',
      'Febrero',
      'Marzo',
      'Abril',
      'Mayo',
      'Junio',
      'Julio',
      'Agosto',
      'Septiembre',
      'Octubre',
      'Noviembre',
      'Diciembre',
    ];
    if (date) {
      const year = date.substr(0, 4);
      const month = date.substr(4, 2);
      const day = date.substr(6, 8);
      // const hourFormated = `${hour.substr(0, 2)}:${hour.substr(2, 4)}`;
      const dateFormated = new Date(`${year}-${month}-${day} 00:00:00`);
      let dayWeek = dateFormated.getDay();
      if (dayWeek === 0) {
        dayWeek = 7;
      }
      // Martes 8 de agosto 8:15AM
      return `${days[dayWeek - 1]} ${day} de ${months[
        parseInt(month, 10) - 1
      ]}`;
    }
    return '';
  };
  render() {
    const url = '/telemedicina/consulta-turnos';
    return (
      <div className="modal fade" id="ModalYaTomoTurno">
        <div className="modal-dialog">
          <div className={`${s.modalContent} modal-content`}>
            <div className="modal-header">
              <h5 className="modal-title">Turno ya asignado</h5>
            </div>
            <div className={`${s.modalBody} modal-body`}>
              <div>
                Ya tenés un turno asignado en E-Consulta para el día{' '}
                <strong>{`${this.showDateModal(
                  this.props.turno.fecha,
                  this.props.turno.hora,
                )}`}</strong>{' '}
                en la especialidad seleccionada.
              </div>
            </div>
            <div className={`${s.modalFooter} modal-footer`}>
              <button
                data-dismiss="modal"
                className={`${s.boton_blanco} ${s.robotoMedium} btn btn-default float-left`}
              >
                Cerrar
              </button>
              <button
                data-dismiss="modal"
                className={`${s.boton_rojo} btn btn-danger text-center`}
                onClick={() => redirectTo(url)}
              >
                Ir a Consulta de turnos
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default connect(null, null)(withStyles(s)(ModalYaTomoTurno));



// WEBPACK FOOTER //
// ./src/components/Telemedicina/ModalYaTomoTurno/ModalYaTomoTurno.js